import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static values = { 
    key: String, 
    type: { type: String, default: "search" },
    delay: { type: Number, default: 300 } 
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.updateURL()
    }, this.delayValue)
  }

  async updateURL() {
    const params = new URLSearchParams(window.location.search)
    const value = this.element.value?.trim()
    
    if (this.typeValue === "direct") {
      // Direct parameter (e.g., status=building)
      if (value) {
        params.set(this.keyValue, value)
      } else {
        params.delete(this.keyValue)
      }
    } else {
      // Search parameter (e.g., search[customer]=john)
      if (value) {
        params.set(`search[${this.keyValue}]`, value)
      } else {
        params.delete(`search[${this.keyValue}]`)
      }
    }
    
    // Reset pagination when filtering
    params.delete('page')
    
    // Make request using @rails/request.js
    const newUrl = `${window.location.pathname}?${params.toString()}`
    
    await get(newUrl, {
      responseKind: 'turbo-stream'
    })
  }
}